import { usePublicBoundlessConfigRetrieveSuspense } from "@boundless/bl-api-client/public/services"

export default function Footer() {
  const { data: config } = usePublicBoundlessConfigRetrieveSuspense()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative z-10 mb-[var(--mobile-dashboard-nav-height)] flex min-h-16 items-center justify-center border-t bg-white px-4 py-3 lg:mb-0">
      <div className="flex flex-col items-center justify-center gap-y-1 text-center sm:flex-row sm:flex-wrap sm:gap-x-6">
        <p className="text-muted-foreground text-xs md:text-sm">
          Copyright Boundless Financial Corp. {currentYear}
        </p>
        <div className="flex flex-nowrap items-center gap-x-6 whitespace-nowrap">
          <a
            className="text-primary text-xs underline underline-offset-4 md:text-sm"
            href={config.privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          <a
            className="text-primary text-xs underline underline-offset-4 md:text-sm"
            href={config.termsOfServiceUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  )
}
